import { environment } from './environments/environment';

const CONSOLE_METHODS = [
  'log',
  'debug',
  'info',
  'warn',
  'error',
  'trace',
  'table',
  'group',
  'groupCollapsed',
  'groupEnd',
  'time',
  'timeEnd',
  'timeLog',
  'count',
  'countReset',
  'assert',
  'clear',
  'dir',
  'dirxml',
  'profile',
  'profileEnd',
] as const;

/** No-op all console methods when running a production build (unless ENABLE_LOGS=true). */
export function disableConsoleInProduction(): void {
  if (!environment.production || environment.enableLogs) {
    return;
  }

  const noop = (): void => undefined;

  for (const method of CONSOLE_METHODS) {
    try {
      (console[method] as (...args: unknown[]) => void) = noop;
    } catch {
      // Some browsers expose read-only console methods.
    }
  }
}
